import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import OwnerSelector from "../components/OwnerSelector";
import TsvUploader from "../../components/TsvUploader";
import Instructions from "./Instructions";
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GPAP_Button, {GPAP_Button_light}  from "../../../../gpap-lib/Button_Collection";
import DoneIcon from '@mui/icons-material/Done';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ReplayIcon from '@mui/icons-material/Replay';
import DownloadIcon from '@mui/icons-material/Download'


const SubmissionHeader = (props) => {
    
    return (
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3}} sx={{mb:2}}>
            <Grid item xs={4}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}
                >
                    { (props.goBackHref !== undefined) ?
                        <Grid item>
                            <Tooltip title="Go back to previous view" placement="top">
                                <GPAP_Button  href={props.goBackHref} id="back"  startIcon={<ArrowBackIcon />}>
                                    BACK
                                </GPAP_Button>
                            </Tooltip>
                        </Grid>
                       :
                           null
                    }

                    { (props.owner !== undefined) ?
                        <Grid item >
                            <OwnerSelector owner={props.owner} setValid={props.ownerValid} 
                                           setOwner={props.setOwner} error={props.ownerError}/>
                        </Grid>   
                       :
                           null
                    }
                </Grid>
            </Grid>
            <Grid item xs={4}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                >
                    <Grid item >
                        <Typography variant={"h5"}> {props.title} </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={4}>    
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    spacing={1}
                >
                    <Grid item >
                        <Instructions/>
                    </Grid> 
                </Grid> 
            </Grid>
            <Grid item xs={6}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}
                >
                    <Grid item >
                        <Tooltip title="Download a template to submit data" placement="bottom">
                            <GPAP_Button_light
                                style={{float:"left"}}
                                id="download"
                                startIcon={<DownloadIcon/>}
                                onClick={props.getExcel}>
                                    TEMPLATE
                            </GPAP_Button_light>
                        </Tooltip>
                    </Grid>

                    <Grid item >
                        <TsvUploader uploadTsv={props.loadFile}/>
                    </Grid>
                    
                    <Grid item>
                        <Tooltip title="Validate the current data in the table" placement="top">
                        <GPAP_Button id="validate"  onClick={props.validate}  startIcon={<DoneIcon />}>
                            VALIDATE
                        </GPAP_Button>
                        </Tooltip>
                    </Grid>
              
                    <Grid item>
                        <Tooltip title="Submit the data" placement="top">
                        <GPAP_Button id="submit"  startIcon={<CloudUploadIcon />} onClick={props.submit}>
                            SUBMIT
                        </GPAP_Button>
                        </Tooltip>
                    </Grid>
                    
                    <Grid item>
                        <GPAP_Button id="reload" onClick={props.reload} startIcon={<ReplayIcon/>}>
                            RESET
                        </GPAP_Button>
                    </Grid>
                    

                </Grid>
            </Grid>
            <Grid item xs={6}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    spacing={1}
                >
                    <Typography variant="h6">Add rows: </Typography>
                    <Grid item>
                        <Tooltip title="Add 1 row to the table" placement="top">
                        <GPAP_Button id="addRow-1" onClick={props.addRow}>+1</GPAP_Button>
                        </Tooltip>
                    </Grid>
                
                    <Grid item>
                        <Tooltip title="Add 10 rows to the table" placement="top">
                        <GPAP_Button id="addRow-10"  onClick={props.addRow}>+10</GPAP_Button>
                        </Tooltip>
                    </Grid>
                   
                    <Grid item>
                        <Tooltip title="Add 100 rows to the table" placement="top">
                        <GPAP_Button id="addRow-100"  onClick={props.addRow}>+100</GPAP_Button>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default SubmissionHeader;
